var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"commonLayouts",staticClass:"common-layout",attrs:{"id":"commonLayouts"},on:{"scroll":_vm.scrolling}},[_c('my-header'),_c('app-main',{staticStyle:{"min-height":"100vh"}}),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }